import React from 'react';

const FormField = ({ label, name, type = 'text', value, onChange, error, required = false, options = [], rows = 1, ...props }) => {
  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  const inputClasses = `
    w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors
    ${error ? 'border-red-500' : 'border-gray-300'}
    ${type === 'select' ? 'bg-white' : ''}
  `;

  return (
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      
      {type === 'textarea' ? (
        <textarea
          name={name}
          value={value}
          onChange={handleChange}
          rows={rows}
          className={inputClasses}
          {...props}
        />
      ) : type === 'select' ? (
        <select
          name={name}
          value={value}
          onChange={handleChange}
          className={inputClasses}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          className={inputClasses}
          {...props}
        />
      )}
      
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
    </div>
  );
};

export default FormField;